import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { render } from "react-dom";
import { ApolloProvider } from "@apollo/client";
import { client } from "./apolloClient";
import { msalInstance } from "./utils/msalConfig";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./polyfills";

const renderApp = () => {
  render(
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>,

    document.getElementById("root")
  );
};

// Initialize MSAL and process any pending Entra redirect response before
// rendering. This is a no-op for the Okta path (no redirect hash to handle).
// The active IdP is resolved later by IdpDiscoveryProvider.
msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .catch((error) => {
    console.error("[index] MSAL initialization failed:", error);
  })
  .finally(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
